import React, { createContext, useContext, useState, useEffect } from 'react';
    import firebaseAuthService from '../services/firebaseAuthService';
    import firebaseInitService from '../services/firebaseInitService';

    const AuthContext = createContext();

    export const useAuth = () => {
      const context = useContext(AuthContext);
      if (!context) throw new Error('useAuth must be used within an AuthProvider');
      return context;
    };

    export const AuthProvider = ({ children }) => {
      const [user, setUser] = useState(null);
      const [isAuthenticated, setIsAuthenticated] = useState(false);
      const [loading, setLoading] = useState(true);

      useEffect(() => {
        // Initialize Auth State
        const unsubscribe = firebaseAuthService.initialize();
        
        const sub = firebaseAuthService.onAuthStateChanged((fbUser) => {
          setUser(fbUser);
          setIsAuthenticated(!!fbUser);
          setLoading(false);

          // Background DB check: Only for Admin
          if (fbUser?.role === 'admin') {
            firebaseInitService.initialize().catch(err => console.warn('Silent Init:', err));
          }
        });

        return () => {
          if (unsubscribe) unsubscribe();
          sub();
        };
      }, []);

      const login = async (emailOrUsername, password) => {
        let email = emailOrUsername;
        if (emailOrUsername.toLowerCase() === 'admin') email = 'admin@expertguru.com';
        return await firebaseAuthService.login(email, password);
      };

      return (
        <AuthContext.Provider value={{
          user,
          isAuthenticated,
          loading,
          login,
          logout: () => firebaseAuthService.logout(),
          createUser: (d) => firebaseAuthService.createUser(d),
          updateUser: (id, d) => firebaseAuthService.updateUser(id, d),
          deleteUser: (id) => firebaseAuthService.deleteUser(id),
          hasPermission: (p) => firebaseAuthService.hasPermission(p),
          sendPasswordReset: (e) => firebaseAuthService.sendPasswordReset(e),
          setNewPasswordAdmin: (uid, pass) => firebaseAuthService.setNewPasswordAdmin(uid, pass)
        }}>
          {children}
        </AuthContext.Provider>
      );
    };